import { render, staticRenderFns } from "./personpic.vue?vue&type=template&id=5413365d&scoped=true&"
import script from "./personpic.vue?vue&type=script&lang=js&"
export * from "./personpic.vue?vue&type=script&lang=js&"
import style0 from "./personpic.vue?vue&type=style&index=0&id=5413365d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5413365d",
  null
  
)

export default component.exports